export interface SurveyLayerNode {
  key: string;
  name: string;
  type: string;
  endpoint: string;
  checked: boolean;
  color?: string;
  loading?: boolean;
  error?: string;
  sourceSlug?: string;
}

export interface SurveyLayerEntry {
  surveySlug: string;
  displayLabel: string;
  layers: SurveyLayerNode[];
  loading: boolean;
  error?: string;
  surveyType?: string;
  surveyYear?: string;
}

export function buildSurveyLabel(surveyType: string, surveyDate: string, runNumber: string): string {
  const parts: string[] = [surveyType];
  if (surveyDate) parts.push(surveyDate);
  if (runNumber) parts.push(`Run ${runNumber}`);
  return parts.join(' — ');
}
